import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const SUBSCRIBE_TO_OFFER_NEWSLETTER: DocumentNode = gql`
  mutation SubscribeToOfferNewsletter($email: String!) {
    subscribeToOfferNewsletter(email: $email)
  }
`;

export const UPDATE_USER_EMAIL: DocumentNode = gql`
  mutation UpdateUserEmail {
    triggerUserEmailSynchronization
  }
`;

export const CHECK_AND_UPDATE_USER_ADDRESS: DocumentNode = gql`
  mutation CheckAndUpdateUserAddress($address: UserAddress!) {
    checkAndUpdateUserAddress(address: $address) {
      isFreshEligible
    }
  }
`;

export const SUBSCRIBE_TO_FRESH_WAITLIST: DocumentNode = gql`
  mutation SubscribeToFreshWaitList(
    $email: String!
    $postalCode: String!
    $street: String!
    $city: String!
    $country: String!
  ) {
    subscribeToFreshWaitList(
      email: $email
      postalCode: $postalCode
      street: $street
      city: $city
      country: $country
    )
  }
`;

export const SUBSCRIBE_TO_ULTRA_FRESH_WAITLIST: DocumentNode = gql`
  mutation SubscribeToUltraFreshWaitList(
    $email: String!
    $postalCode: String!
    $street: String!
    $city: String!
    $country: String!
  ) {
    subscribeToUltraFreshWaitList(
      email: $email
      postalCode: $postalCode
      street: $street
      city: $city
      country: $country
    )
  }
`;

export const CREATE_AUTH_TOKEN: DocumentNode = gql`
  mutation CreateAuthToken {
    createAuthToken
  }
`;

export const CREATE_YUMA_CHAT_TOKEN: DocumentNode = gql`
  mutation CreateYumaChatToken {
    createYumaChatToken
  }
`;
